export const inspectionTemplate = {
  overdue: { label: "Overdue" },
  missed: { label: "Missed" },
  upcoming: { label: "Upcoming", secondVal: "Future Inspection" },
  inProgress: { label: "In Progress" },
  completed: { label: "Finished" },
};



// WEBPACK FOOTER //
// ./src/templates/InspectionTemplate.js